import dayjs from 'dayjs';
import { endsWith, isArray, join, map, reduce, split, isEmpty, startsWith, isDate } from 'lodash';

export const searchParamsToForm = (searchParams) => {
  const spObj = reduce(Array.from(searchParams.keys()), (acc, key) => {
    if (endsWith(key, 'Ids')) {
      const idsStrArr = split(searchParams.get(key), ',');
      acc[key] = map(idsStrArr, x => parseInt(x, 10));
    } else {
      acc[key] = searchParams.get(key);
    }
    return acc;
  }, {});

  return spObj;
};

const inferSearchParamName = ( term ) => {
  if (/\s*(([a-z\/]+\(((19)?[56789]\d|20?[0-9]{2}\d)\)[a-z\/\d]*)|(OECD\/LEGAL\/[0-9]{4})|[0-9]{1,4})/i.test( term ) ) {
    return 'reference';
  }
  return 'term';
};

export const formToSearchParams = (obj, isQuickSearch = false) => {
  const objSp = reduce(obj, (acc, val, key) => {
    if (val) {
      if (isArray(val) && !isEmpty(val)) {
        acc[key] = join(val, ',')
      } else if (isDate(val)) {
        acc[key] = dayjs(val).format('YYYY-MM-DD');
      } else if (key === 'reference' && !isNaN(val)) {
        acc[key] = `OECD/LEGAL/${String(val).padStart(4, '0')}`
      } else if (key === 'reference' && startsWith(val, 'OECD/LEGAL/')) {
        acc['reference'] = val;
      } else if (key === 'reference' && isQuickSearch) {
        acc[inferSearchParamName(val)] = val;
        acc.searchScope = 'titles';
        acc.dateType = 'adoption';
      } else if (!isArray(val)) {
        acc[key] = val;
      }
    }
    return acc;
  }, {});

  if (objSp.searchScope && !objSp.term) {
    delete objSp.searchScope;
  }
  if (objSp.term && !objSp.searchScope) {
    objSp.searchScope = 'fullText';
  }

  return objSp;
};


export const searchParamsToApiParams = (searchParams, lang) => {
  const apiQueryParams = Object.fromEntries(searchParams);

  if (apiQueryParams.lastPublishedDateStart) {
    apiQueryParams.lastPublishedDateRange = `${apiQueryParams.lastPublishedDateStart},${apiQueryParams.lastPublishedDateEnd}`;
    delete apiQueryParams.lastPublishedDateStart;
    delete apiQueryParams.lastPublishedDateEnd;
  }

  if (apiQueryParams.yearFrom || apiQueryParams.yearTo) {
    const yearFrom = !apiQueryParams.yearFrom ? '' : `${apiQueryParams.yearFrom}-01-01`;
    const yearTo = !apiQueryParams.yearTo ? '' : `${apiQueryParams.yearTo}-12-31`;
    apiQueryParams.adoptionDateRange = `${yearFrom},${yearTo}`;
    delete apiQueryParams.yearFrom;
    delete apiQueryParams.yearTo;
  }

  // delete apiQueryParams.mode;
  delete apiQueryParams.publishStatus;

  apiQueryParams.lang = lang;
  return apiQueryParams;
};